
function ChartAnnotationText({ text }) {
  return (
    <div className="px-1 py-0.5 text-xs sm:text-sm">
      {text}
    </div>
  )
}

export default ChartAnnotationText;
